import { combineReducers } from 'redux';
import { devicesReducer } from './devices.reducer';
import { brigadesReducer } from './brigades.reducer';
import { uippsReducer } from './uipps.reducer';
import { userReducer } from './user.reducer';
import { optionsReducer } from './options.reducer';
import { statusesReducer } from './statuses.reducer';
import { errorReducer } from './error.reducer';
import { loaderReducer } from './loader.reducer';
import { archiveReducer } from './archive.reducer';
import { kuobzReducer } from './kuobz.reducer';
import { filesReducer } from './files.reducer';
import { languageReducer } from './language.reducer';
import adminReducer from './admin.reducer';
import infocardReducer from './infocard.reducer';
import { mapMarkersReducer } from './mapMarkers.reducer';
import { sortDataReducer } from './sortData.reducer';
import { lastQueryReducer } from './lastQuery.reducer';

export const rootReducer = combineReducers({
  user: userReducer,
  brigadesState: brigadesReducer,
  devices: devicesReducer,
  uipps: uippsReducer,
  kuobzes: kuobzReducer,
  infocards: infocardReducer,
  archive: archiveReducer,
  files: filesReducer,
  statuses: statusesReducer,
  mapMarkers: mapMarkersReducer,
  options: optionsReducer,
  adminData: adminReducer,
  sortData: sortDataReducer,
  loader: loaderReducer,
  language: languageReducer,
  error: errorReducer,
  lastQuery:lastQueryReducer,
});
